"use strict";

var _regeneratorRuntime = require("/var/www/attheme-editor.snejugal.ru/node_modules/@babel/runtime/regenerator");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var attheme_js_1 = require("attheme-js");

var isNode = require("detect-node");

var makeRequest;

var createOpenInEditorLink = function createOpenInEditorLink(themeId) {
  return "https://attheme-editor.snejugal.ru/?themeId=".concat(themeId);
};

var uploadTheme = function uploadTheme(_ref) {
  var name = _ref.name,
      theme = _ref.theme;
  return __awaiter(void 0, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee() {
    var content, _ref2, themeId;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            content = theme.toString();

            if (isNode) {
              content = Buffer.from(content, "binary").toString("base64");
            } else {
              content = btoa(content);
            }

            _context.next = 4;
            return makeRequest({
              requestType: "uploadTheme",
              name: name,
              content: content
            });

          case 4:
            _ref2 = _context.sent;
            themeId = _ref2.themeId;
            return _context.abrupt("return", themeId);

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
};

var downloadTheme = function downloadTheme(themeId) {
  return __awaiter(void 0, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2() {
    var _ref3, name, content, decodedContent, theme;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return makeRequest({
              requestType: "downloadTheme",
              themeId: themeId
            });

          case 2:
            _ref3 = _context2.sent;
            name = _ref3.name;
            content = _ref3.content;

            if (isNode) {
              decodedContent = Buffer.from(content, "base64").toString("binary");
            } else {
              decodedContent = atob(content);
            }

            theme = new attheme_js_1["default"](decodedContent);
            return _context2.abrupt("return", {
              name: name,
              theme: theme
            });

          case 8:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
};

exports["default"] = function (fetcher) {
  makeRequest = fetcher;
  return {
    createOpenInEditorLink: createOpenInEditorLink,
    uploadTheme: uploadTheme,
    downloadTheme: downloadTheme
  };
};

exports.API_URL = "https://attheme-editor.snejugal.ru/api/";